import type { StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const eventWidgetPhotoStyles = (photoUrl?: string): StyleSystemProps => ({
  display: 'flex',
  height: pxToRem(40),
  width: pxToRem(40),
  borderRadius: pxToRem(40),
  backgroundColor: 'gray5',
  backgroundImage: photoUrl && `url('${photoUrl}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
});

export const styles = {
  eventWidgetPhoto: eventWidgetPhotoStyles,
};
